<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <div class="text-center mb-4">
            <img
              src="img/brand/logo.png"
              style="width: 100%; max-width: 230px"
            />
          </div>
          <new-password-form
            v-if="requires_new_password"
            :username="username"
            @clearPasswordReset="clearPasswordReset"
          ></new-password-form>
          <div v-else>
            <b-card
              img-src="img/login-bg.jpg"
              img-alt="Image"
              img-top
              tag="article"
              class="mb-2"
            >
              <b-form class="px-4" @submit.prevent="signIn">
                <p class="alert alert-warning" v-if="error_msg">
                  {{ error_msg }}
                </p>
                <b-input-group class="mb-3">
                  <b-input-group-prepend
                    ><b-input-group-text
                      ><i class="icon-user"></i></b-input-group-text
                  ></b-input-group-prepend>
                  <b-form-input
                    :disabled="logging_in"
                    type="text"
                    class="form-control"
                    placeholder="Your email"
                    autocomplete="username email"
                    v-model="username"
                  />
                </b-input-group>
                <b-input-group class="mb-4">
                  <b-input-group-prepend
                    ><b-input-group-text
                      ><i class="icon-lock"></i></b-input-group-text
                  ></b-input-group-prepend>
                  <b-form-input
                    :disabled="logging_in"
                    type="password"
                    class="form-control"
                    placeholder="Your password"
                    autocomplete="current-password"
                    v-model="password"
                  />
                </b-input-group>
                <b-row>
                  <b-col>
                    <b-button
                      v-if="!logging_in"
                      variant="primary"
                      block
                      class="text-uppercase font-weight-bold py-2"
                      type="submit"
                      @click="signIn"
                      >Log In</b-button
                    >
                    <b-button
                      v-else
                      variant="default"
                      block
                      class="text-uppercase font-weight-bold py-2 text-muted"
                    >
                      <i class="fal fa-spin fa-spinner"></i> Logging in...
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </b-card>
            <b-row>
              <b-col>
                <b-button
                  variant="link"
                  block
                  class="px-0 pt-3 text-center"
                  to="/password/reset"
                  >Recover password?</b-button
                >
              </b-col>
            </b-row>
            <div class="mt-4"></div>
            <!--<b-row>-->
            <!--<b-col>-->
            <!--<p class="text-center font-italic pt-4 pb-3">Creating an account streamlines sample submission, billing, and notifications. We can not accept anonymous sample submissions, and we need to know where to send you notifications when your samples are processed. We will never spam you and we will protect your information and privacy.</p>-->
            <!--</b-col>-->
            <!--</b-row>-->
            <!--<b-row  class="justify-content-center">-->
            <!--<b-col md="6">-->
            <!--<b-button variant="primary" block class="text-center font-2xl" to="register">Register (1 min)</b-button>-->
            <!--<div class="text-center p-3">-->
            <!--<i class="fab fa-facebook font-2xl pr-2" @click="inviteUser"></i>-->
            <!--<i class="fab fa-google font-2xl pr-2"></i>-->
            <!--<i class="fab fa-amazon font-2xl pr-2"></i>-->
            <!--</div>-->
            <!--</b-col>-->
            <!--</b-row>-->
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  AUTH_LOGIN,
  AUTH_CHECK_LOGIN,
  AUTH_INVITE,
} from "@/store/action-types";
import NewPasswordForm from "../../components/auth/NewPasswordForm";

export default {
  components: { NewPasswordForm },
  name: "Login",
  data() {
    return {
      username:
        this.$store.getters.getAuthenticatedUsername || "kolby@tangle.ca",
      password: "Password1!",
      error_msg: null,
      cognito_username: null,
      requires_new_password: false,
      logging_in: false,
    };
  },
  methods: {
    signIn() {
      this.logging_in = true;

      const username = this.username;
      const password = this.password;
      this.error_msg = null;

      this.$store
        .dispatch(AUTH_LOGIN, { username, password })
        .then((data) => {
          const status = this.$store.getters.getAuthenticationStatus;
          if (status === "sign_in__success") {
            this.$router.push("/dashboard");
          } else if (status === "sign_in__password_required") {
            this.requires_new_password = true;
          }
          this.logging_in = false;
        })
        .catch((err) => {
          const error = this.$store.getters.getAuthenticationError;
          if (error) {
            this.error_msg = error;
          } else {
            this.error_msg =
              "Something went wrong please contact an administrator";
          }
          this.logging_in = false;
        });
    },

    clearPasswordReset() {
      this.requires_new_password = false;
    },

    // inviteUser() {
    //   this.$store.dispatch(AUTH_INVITE, {email: 'kwittmack@gmail.com'}).then(data => {
    //     this.error_msg = 'Invite Success'
    //   }).catch(err => {
    //     const error = this.$store.getters.getAuthenticationError;
    //     if(error) {
    //       this.error_msg = error
    //     } else {
    //       this.error_msg = 'Something went wrong please contact an administrator';
    //     }
    //   });
    // }
  },
  async beforeCreate() {
    this.$store
      .dispatch(AUTH_CHECK_LOGIN, {})
      .then((data) => {
        this.$router.push("/dashboard");
      })
      .catch((e) => {
        //:: TODO handle check
      });
  },
};
</script>
